<template>
	<div class="about-xs" style="position:relative;">

		<div class="aw-register-box about-box">
			<div class="mod-body clearfix gxgd">
				<div class="content   aboutx">
					<div class="about-t">
						&nbsp; &nbsp;&nbsp; &nbsp; 数据库作为服务器，通常多是安装在linux操作系统中的，咱们这里展示如何在centos7的操作系统上安装mysql8.0数据库，个人用户可以安装一个虚拟机来搭建linux环境。</br>
						&nbsp; &nbsp;&nbsp; &nbsp; 本站注册用户可以使用在线编辑器功能完成sql的学习，可以直接跳过本节内容。
						<div style="padding-left: 50px;">
							<img style="width: 40px;" :src="require('../../assets/image/jiantou.png')">
							<a @click="toRunSql">打开我的在线sql学习编辑器 </a></br>
						</div>
					</div>
					<h1 style="color: #2d8cf0;">1、下载安装包</h1>
					<div class="about-t">
						&nbsp; &nbsp;&nbsp; &nbsp; [root] cd /usr/local/src </br>
						&nbsp; &nbsp;&nbsp; &nbsp; [root] wget
						https://dev.mysql.com/get/Downloads/MySQL-8.0/mysql-8.0.20-linux-glibc2.12-x86_64.tar.xz
					</div>
					<h1 style="color: #2d8cf0;"> 2、解压安装包</h1>
					<div class="about-t">
						&nbsp; &nbsp;&nbsp; &nbsp; [root] xz -d mysql-8.0.20-linux-glibc2.12-x86_64.tar.xz </br>
						&nbsp; &nbsp;&nbsp; &nbsp; [root] tar xvf mysql-8.0.20-linux-glibc2.12-x86_64.tar </br>
					</div>
					<h1 style="color: #2d8cf0;"> 3、移动安装包</h1>
					<div class="about-t">
						&nbsp; &nbsp;&nbsp; &nbsp; [root] cd /usr/local </br>
						&nbsp; &nbsp;&nbsp; &nbsp; [root] mkdir mysql </br>
						&nbsp; &nbsp;&nbsp; &nbsp; [root] cd /usr/local/src </br>
						&nbsp; &nbsp;&nbsp; &nbsp; [root] mv /usr/local/src/mysql-8.0.20-linux-glibc2.12-x86_64/*
						/usr/local/mysql </br>
						&nbsp; &nbsp;&nbsp; &nbsp; [root] cd /usr/local/mysql </br>
					</div>
					<h1 style="color: #2d8cf0;"> 4、创建用户组及用户并授权</h1>
					<div class="about-t">
						&nbsp; &nbsp;&nbsp; &nbsp; [root] groupadd mysql </br>
						&nbsp; &nbsp;&nbsp; &nbsp; [root] useradd -g mysql mysql </br>
						&nbsp; &nbsp;&nbsp; &nbsp; [root] chown -R mysql.mysql /usr/local/mysql </br>
					</div>
					<h1 style="color: #2d8cf0;"> 5、编辑my.cnf文件</h1>
					<div class="about-t">
						&nbsp; &nbsp;&nbsp; &nbsp;[mysqld]</br>
						&nbsp; &nbsp;&nbsp; &nbsp;user=root</br>
						&nbsp; &nbsp;&nbsp; &nbsp;datadir=/usr/local/mysql/data</br>
						&nbsp; &nbsp;&nbsp; &nbsp;basedir=/usr/local/mysql</br>
						&nbsp; &nbsp;&nbsp; &nbsp;port=3306</br>
						&nbsp; &nbsp;&nbsp; &nbsp;max_connections=200</br>
						&nbsp; &nbsp;&nbsp; &nbsp;max_connect_errors=10</br>
						&nbsp; &nbsp;&nbsp; &nbsp;character-set-server=utf8</br>
						&nbsp; &nbsp;&nbsp; &nbsp;default-storage-engine=INNODB</br>
						&nbsp; &nbsp;&nbsp; &nbsp;default_authentication_plugin=mysql_native_password</br>
						&nbsp; &nbsp;&nbsp; &nbsp;lower_case_table_names=1</br>
						&nbsp; &nbsp;&nbsp; &nbsp;group_concat_max_len=102400</br>
						&nbsp; &nbsp;&nbsp; &nbsp;[mysql]</br>
						&nbsp; &nbsp;&nbsp; &nbsp;default-character-set=utf8</br>
						&nbsp; &nbsp;&nbsp; &nbsp;[client]</br>
						&nbsp; &nbsp;&nbsp; &nbsp;port=3306</br>
						&nbsp; &nbsp;&nbsp; &nbsp;default-character-set=utf8</br>
					</div>
					<h1 style="color: #2d8cf0;"> 6、初始化数据库</h1>
					<div class="about-t">
						&nbsp; &nbsp;&nbsp; &nbsp; [root] cd bin </br>
						&nbsp; &nbsp;&nbsp; &nbsp; [root] ./mysqld --initialize </br>
						&nbsp; &nbsp;&nbsp; &nbsp; [root] [Note] [MY-010454] [Server] A temporary password is generated for root@localhost: OLOkz_e)c8Jw </br> 
					    &nbsp; &nbsp;&nbsp; &nbsp;注意上面最后一行生成的默认密码：OLOkz_e)c8Jw  后面登录要用
					</div>
					<h1 style="color: #2d8cf0;"> 7、添加mysqld服务到系统，授权以及添加服务</h1>
					<div class="about-t">
						&nbsp; &nbsp;&nbsp; &nbsp; [root] cd .. </br>
						&nbsp; &nbsp;&nbsp; &nbsp; [root] cp -a ./support-files/mysql.server /etc/init.d/mysql </br>
						&nbsp; &nbsp;&nbsp; &nbsp; [root] chmod +x /etc/init.d/mysql</br> 
						&nbsp; &nbsp;&nbsp; &nbsp; [root] chkconfig --add mysql</br> 
					</div>
					<h1 style="color: #2d8cf0;"> 8、启动mysql</h1>
					<div class="about-t">
						&nbsp; &nbsp;&nbsp; &nbsp; [root]service mysql start </br>
					</div>
					<h1 style="color: #2d8cf0;"> 9、将mysql添加到命令服务</h1>
					<div class="about-t">
						&nbsp; &nbsp;&nbsp; &nbsp; [root] ln -s /usr/local/mysql/bin/mysql /usr/bin </br>
					</div>
					<h1 style="color: #2d8cf0;"> 10、登录mysql</h1>
					<div class="about-t">
						&nbsp; &nbsp;&nbsp; &nbsp; [root] 注：输入第6步中生成的初始密码 </br>
						&nbsp; &nbsp;&nbsp; &nbsp; [root] mysql -uroot -p </br>
						&nbsp; &nbsp;&nbsp; &nbsp; Enter password:</br>
						&nbsp; &nbsp;&nbsp; &nbsp; Welcome to the MySQL monitor.  Commands end with ; or \g.</br>
						&nbsp; &nbsp;&nbsp; &nbsp; Your MySQL connection id is 8</br>
						&nbsp; &nbsp;&nbsp; &nbsp; Server version: 8.0.20</br>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
 

	import SqlShow from '@/components/project/SqlShow.vue'
	export default {
		components: {

			SqlShow,
		},

		data() {
			return {
				 
	 
			}
		},

		created() {
			this.userId = this.$store.state.userInfo.userId;
			if (this.userId != undefined) {
				this.ifLogin = true;
			}
			console.log('userId:' + this.userId);
		},
		computed: {

		},
		methods: {

			toRunSql() {
				if (this.ifLogin == true) {
					 this.$router.push('/partDemo')
				} else {
					 this.$Message.warning('请登录后体验该功能！');
				}
			}

		},

	}
</script>


<style lang="scss" scoped>
	#vip {
		color: red;

	}

	.about-xs {

		margin-bottom: 20px;
		margin-top: 10px;
	}

	//标题字体
	.aw-register-box .mod-body .content h2.about-cs {
		padding-top: 10px;
		color: #2d8cf0;
		font-size: 24px;
		height: 50px;
		text-align: left;
		font-weight: bold;
	}

	//内容字体	
	.aw-register-box .mod-body .content .about-t {
		width: 1040px;
		height: auto;
		overflow: hidden;
		text-align: left;
		font-size: 18px;
		line-height: 60px;
	}


	.aw-register-box .mod-body .content .about-t .at-r {
		width: 596px;
		height: auto;
		float: right;
		text-align: center;
	}

	.aw-register-box .mod-body {
		padding: 10px 10px 10px 10px;
	}

	.aw-register-box .gxgd {
		padding: 10px 10px 10px 10px;
	}


	.about-box {
		width: 1170px;
		margin: 20px;
		background-color: #fff;
		border-radius: 0;
		-webkit-box-shadow: 0 0 4px rgba(0, 0, 0, .1);
		-moz-box-shadow: 0 0 4px rgba(0, 0, 0, .1);
		box-shadow: 0 0 4px rgba(0, 0, 0, .1);
	}




	.aw-register-box .mod-body .content .about-t .at-l {
		width: 442px;
		height: auto;
		padding-top: 80px;
		float: left;
		text-align: left;
	}

	.aw-register-box .mod-body .content .about-t .at-l2 {
		width: 496px;
		height: auto;
		float: left;
		text-align: center;
	}

	.aw-register-box .mod-body .content h2.about-cs font {
		color: #e37626;
		font-size: 24px;
	}

	.aw-register-box .mod-bodyx .content h2 {
		margin: 0 0 13px 0;
		color: #333;
		font-size: 18px;
	}

	.aw-register-box .mod-body .content h2.t-center {
		text-align: center;
	}

	.aw-register-box .mod-body .mod-bodyt h2.t-center {
		text-align: center;
	}
</style>
